<template>
  <div>
    <v-form>
      <v-select
        v-model="value.environmentIds"
        :items="environments"
        item-text="description"
        item-value="id"
        multiple
      />
      <v-text-field v-model="value.code" label="Code"></v-text-field>
      <v-text-field v-model="value.userName" label="UserName"></v-text-field>
      <v-text-field
        v-model="value.password"
        type="password"
        label="Password"
      ></v-text-field>
      <v-text-field
        v-model="value.confirmPassword"
        type="password"
        label="Confirm Password"
      ></v-text-field>
    </v-form>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default() {
        return {
          userName: "",
          password: "",
          confirmPassword: "",
          environmentIds: [],
        };
      },
    },
  },

  data() {
    return {
      environments: [],
    };
  },
  watch: {
    async value() {
      await this.getEnvironments();
    },
  },
  methods: {
    async getEnvironments() {
      let res = await this.$http.get("environment");
      if (res.success) this.environments = res.data.data;
      else this.alert.alerts = res.data;
    },
  },
  async mounted() {
    await this.getEnvironments();
  },
};
</script>